// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../styles/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*@import url("styles/index.css"); */

.text-area {
	margin-bottom: 4rem;
	width: 100%;
}
.text-area h1 {
	margin-bottom: 1rem;
}
.text-area strong,
.text-area .strong {
	font-family: "Inter", sens-serif;
	font-weight: bold;
}
.chart-indicators {
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	width: 100%;
}
.chart-indicators.placeholder {
	min-height: 301px;
	min-width: 240px;
	box-shadow: unset;
	filter: unset;
}
.chart-indicators .note {
	float: right;
	font-size: 1rem;
}
.chart-indicators p {
	margin-left: 1rem;
	margin-bottom: 0.5rem;
	line-height: 1.4rem;
	font-size: 1.2rem;
}
.chart-indicators div {
	margin-right: 1rem;
	margin-bottom: 0.5rem;
	line-height: 1.4rem;
	font-size: 1.2rem;
	background-color: var(--www-color-float-bg1);
	border-radius: 1rem;
	width: 100%;
}
.chart-indicators ul {
	margin: 0.5rem;
	line-height: 1.2rem;
	font-size: 1.2rem;
	list-style-position: inside;
	list-style-type: none;
	text-indent: 2rem;
}
.chart-indicators .chart-indicators-row {
	display: flex;
	justify-content: flex-start;
	align-items: baseline;
	padding-top: 0.5rem;
}
.chart-indicators .chart-indicators-row p {
	width: 40%;
}
.chart-indicators .chart-indicators-row div {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	width: 60%;
}
.chart-indicators .chart-indicators-row div p {
	margin: 0;
	width: 100%;
}
.chart-indicators .chart-indicators-vector {
	padding-top: 0.5rem;
}

@media (min-width: 500px) {
	.chart-indicators p {
		margin-bottom: 0.5rem;
		line-height: 1.8rem;
		font-size: 1.6rem;
	}
	.chart-indicators ul {
		margin: 0.5rem;
		line-height: 1.8rem;
		font-size: 1.6rem;
	}
	.chart-indicators .note {
		float: right;
		font-size: 1.2rem;
	}
	.chart-indicators .chart-indicators-row {
		padding-top: 0rem;
	}
	.chart-indicators .chart-indicators-vector {
		padding-top: 0rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/ChartIndicators/ChartIndicators.css"],"names":[],"mappings":"AACA,oCAAoC;;AAEpC;CACC,mBAAmB;CACnB,WAAW;AACZ;AACA;CACC,mBAAmB;AACpB;AACA;;CAEC,gCAAgC;CAChC,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,eAAe;CACf,WAAW;AACZ;AACA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;CACjB,aAAa;AACd;AACA;CACC,YAAY;CACZ,eAAe;AAChB;AACA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,mBAAmB;CACnB,iBAAiB;AAClB;AACA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,mBAAmB;CACnB,iBAAiB;CACjB,4CAA4C;CAC5C,mBAAmB;CACnB,WAAW;AACZ;AACA;CACC,cAAc;CACd,mBAAmB;CACnB,iBAAiB;CACjB,2BAA2B;CAC3B,qBAAqB;CACrB,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,2BAA2B;CAC3B,qBAAqB;CACrB,mBAAmB;AACpB;AACA;CACC,UAAU;AACX;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,2BAA2B;CAC3B,UAAU;AACX;AACA;CACC,SAAS;CACT,WAAW;AACZ;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC;EACC,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;CAClB;CACA;EACC,cAAc;EACd,mBAAmB;EACnB,iBAAiB;CAClB;CACA;EACC,YAAY;EACZ,iBAAiB;CAClB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,iBAAiB;CAClB;AACD","sourcesContent":["@import url(\"styles/colors.css\");\n/*@import url(\"styles/index.css\"); */\n\n.text-area {\n\tmargin-bottom: 4rem;\n\twidth: 100%;\n}\n.text-area h1 {\n\tmargin-bottom: 1rem;\n}\n.text-area strong,\n.text-area .strong {\n\tfont-family: \"Inter\", sens-serif;\n\tfont-weight: bold;\n}\n.chart-indicators {\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex-wrap: wrap;\n\twidth: 100%;\n}\n.chart-indicators.placeholder {\n\tmin-height: 301px;\n\tmin-width: 240px;\n\tbox-shadow: unset;\n\tfilter: unset;\n}\n.chart-indicators .note {\n\tfloat: right;\n\tfont-size: 1rem;\n}\n.chart-indicators p {\n\tmargin-left: 1rem;\n\tmargin-bottom: 0.5rem;\n\tline-height: 1.4rem;\n\tfont-size: 1.2rem;\n}\n.chart-indicators div {\n\tmargin-right: 1rem;\n\tmargin-bottom: 0.5rem;\n\tline-height: 1.4rem;\n\tfont-size: 1.2rem;\n\tbackground-color: var(--www-color-float-bg1);\n\tborder-radius: 1rem;\n\twidth: 100%;\n}\n.chart-indicators ul {\n\tmargin: 0.5rem;\n\tline-height: 1.2rem;\n\tfont-size: 1.2rem;\n\tlist-style-position: inside;\n\tlist-style-type: none;\n\ttext-indent: 2rem;\n}\n.chart-indicators .chart-indicators-row {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: baseline;\n\tpadding-top: 0.5rem;\n}\n.chart-indicators .chart-indicators-row p {\n\twidth: 40%;\n}\n.chart-indicators .chart-indicators-row div {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: flex-start;\n\twidth: 60%;\n}\n.chart-indicators .chart-indicators-row div p {\n\tmargin: 0;\n\twidth: 100%;\n}\n.chart-indicators .chart-indicators-vector {\n\tpadding-top: 0.5rem;\n}\n\n@media (min-width: 500px) {\n\t.chart-indicators p {\n\t\tmargin-bottom: 0.5rem;\n\t\tline-height: 1.8rem;\n\t\tfont-size: 1.6rem;\n\t}\n\t.chart-indicators ul {\n\t\tmargin: 0.5rem;\n\t\tline-height: 1.8rem;\n\t\tfont-size: 1.6rem;\n\t}\n\t.chart-indicators .note {\n\t\tfloat: right;\n\t\tfont-size: 1.2rem;\n\t}\n\t.chart-indicators .chart-indicators-row {\n\t\tpadding-top: 0rem;\n\t}\n\t.chart-indicators .chart-indicators-vector {\n\t\tpadding-top: 0rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
